import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Tengo que cocinar cosas raras?',
    answer: 'No. Todo se encuentra en un supermercado normal. El secreto está en la combinación, no en el exotismo.'
  }, {
    question: '¿Funciona si ya pasé la menopausia?',
    answer: 'Sí. El equilibrio hormonal es vital tanto en la perimenopausia como en la post-menopausia.'
  }, {
    question: '¿Es seguro si tomo medicación?',
    answer: 'Este es un plan basado en comida real. Sin embargo, siempre recomendamos mostrarle la lista de alimentos a tu médico.'
  }, {
    question: '¿Soy muy mayor para esto?',
    answer: "Nunca. Tu metabolismo no 'muere', solo se 'duerme'. Vamos a despertarlo."
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <div className="text-center mb-16" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-brand-green" data-id="element-129">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-brand-gray/70" data-id="element-130">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-131">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-132" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={false} className="border border-brand-cream rounded-2xl overflow-hidden bg-white hover:border-brand-gold/30 transition-colors" data-id="element-133">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-134">
        <span className="font-bold text-lg text-brand-gray pr-4" data-id="element-135">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 w-8 h-8 bg-brand-cream rounded-full flex items-center justify-center" data-id="element-136">
          <ChevronDown className="w-5 h-5 text-brand-green" data-id="element-137" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-138">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-139">
            <div className="px-6 pb-5 text-brand-gray/80 leading-relaxed border-t border-brand-cream pt-4" data-id="element-140">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}